import { render, staticRenderFns } from "./memberCardSubscribeList.vue?vue&type=template&id=84bd4516&scoped=true&"
import script from "./memberCardSubscribeList.vue?vue&type=script&lang=js&"
export * from "./memberCardSubscribeList.vue?vue&type=script&lang=js&"
import style0 from "./memberCardSubscribeList.vue?vue&type=style&index=0&id=84bd4516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd4516",
  null
  
)

export default component.exports